var PaymentFlow;
(function(PaymentFlow) {
    PaymentFlow["REDIRECT"] = 'Redirect';
    PaymentFlow["ACTIONLESS"] = 'Actionless';
    PaymentFlow["QR_CODE"] = 'QrCode';
    PaymentFlow["UNDEFINED"] = 'Undefined';
})(PaymentFlow || (PaymentFlow = {}));

export { PaymentFlow };
//# sourceMappingURL=types.js.map
